/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipping customs vary by country, but 15–20% of the bill is common in the United States for table service.`)
};

const es_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las costumbres de propina varían según el país, pero en Estados Unidos es común dejar entre el 15% y el 20% de la cuenta por el servicio de mesa.`)
};

const de_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinkgeldgepflogenheiten variieren je nach Land, aber 15–20 % der Rechnung sind in den USA für Bedienung am Tisch üblich.`)
};

const nl_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fooigewoontes verschillen per land, maar 15–20% van de rekening is gebruikelijk in de Verenigde Staten voor bediening aan tafel.`)
};

const fr_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les usages en matière de pourboire varient selon le pays, mais 15 à 20 % de l'addition est courant aux États-Unis pour le service en salle.`)
};

const it_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le usanze sulle mance variano da paese a paese, ma negli Stati Uniti è comune dare il 15–20% del conto per il servizio al tavolo.`)
};

const pt_br2_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os costumes de gorjeta variam por país, mas 15–20% da conta é comum nos Estados Unidos para atendimento à mesa.`)
};

const pt_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os costumes de gorjeta variam por país, mas 15–20% da conta é comum nos Estados Unidos para serviço de mesa.`)
};

const ja_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップの慣習は国によって異なりますが、アメリカのテーブルサービスでは会計額の15〜20%が一般的です。`)
};

const zh_pct_tip_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小费习惯因国家而异，但在美国，堂食服务通常给账单金额的 15%–20%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq1_a", locale)
	if (locale === "en") return en_pct_tip_faq1_a(inputs)
	if (locale === "es") return es_pct_tip_faq1_a(inputs)
	if (locale === "de") return de_pct_tip_faq1_a(inputs)
	if (locale === "nl") return nl_pct_tip_faq1_a(inputs)
	if (locale === "fr") return fr_pct_tip_faq1_a(inputs)
	if (locale === "it") return it_pct_tip_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq1_a(inputs)
	if (locale === "pt") return pt_pct_tip_faq1_a(inputs)
	if (locale === "ja") return ja_pct_tip_faq1_a(inputs)
	return zh_pct_tip_faq1_a(inputs)
};